import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { get, orderBy } from 'lodash';
import dateFormat from 'dateformat';
import { toast } from 'react-toastify';
import { Calendar } from '../../../components/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { addLocale } from 'primereact/api';
import { Input100px, Input155px } from '../../../styles/inputGroup';
import Card from '../../../components/card';
import Loading from '../../loading';

import * as actions from '../../../store/modules/auth/actions';

import { formataMoeda, displayErrors } from '../../../util/diversos';

import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';

export default function RelatorioCTe() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const idUsuario = get(store.getState().auth.user, 'id', 0);

  const [findDataInicial, setFindDataInicial] = useState(null);
  const [findDataFinal, setFindDataFinal] = useState(null);
  const [cnpjEmpresa, setCnpjEmpresa] = useState('');
  const [listaEmpresas, setListaEmpresas] = useState([]);
  const [codSit, setCodSit] = useState('REGULAR');
  const [ordenarPorCidade, setOrdenarPorCidade] = useState(false);

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 99999,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: null,
  });

  addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'hoje',
    clear: 'Limpar',
  });

  const listaSituacaoDocumento = [
    { label: 'Todos', value: 'TODOS' },
    { label: 'Regular', value: 'REGULAR' },
    { label: 'Cancelado', value: 'CANCELADO' },
  ];

  const headRows = [
    {
      data: 'Emissão',
      numero: 'Número',
      serie: 'Série',
      chaveAcesso: 'Chave de Acesso',
      tomador: 'Tomador',
      destino: 'Destino',
      codSit: 'Situação',
      totalCt: 'Total Nota',
    },
  ];

  // eslint-disable-next-line no-shadow
  const getData = async (searchFilter, filtrarCnpjEmpresa, page, size = 99999, img) => {
    // eslint-disable-next-line new-cap
    const doc = new jsPDF();
    try {
      setIsLoading(true);

      if (findDataInicial == null && findDataFinal == null) {
        toast.info('Datas devem ser informadas.');
        return;
      }

      if (findDataInicial > findDataFinal) {
        toast.info('Data final anterior a data inicial.');
        return;
      }

      let params = `/cte/search?idUsuario=${idUsuario}`;

      if (filtrarCnpjEmpresa !== '') {
        params = `${params}&cnpjEmpresa=${filtrarCnpjEmpresa}`;
      }

      if (searchFilter && searchFilter.findDataInicial !== '') {
        const _dataInicial = dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy');
        const _dataFinal = dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy');

        params = `${params}&dataInicial=${_dataInicial}&dataFinal=${_dataFinal}`;
      }

      if (codSit !== 'TODOS') {
        params = `${params}&situacao=${codSit}`;
      }

      params = `${params}&page=${page}&size=${size}`;

      const response = await axiosAdmin.get(params);

      console.log('response cte: ', response.data.content);

      if (response.data <= 0) {
        toast.info('Não há registros a serem exibidos.');
        return;
      }

       //se ordenar por cidade
      let dados = response.data.content;
      if (ordenarPorCidade) {
        dados = orderBy(dados, ['xmunFim', 'codSit'], 'asc');
      }

      let data = {
        data: '',
        numero: '',
        serie: '',
        chaveAcesso: '',
        tomador: '',
        destino: '',
        codSit: '',
        totalCt: '',
      };

      const result = [];

      // preencher os dados do relatorio
      let valorTotalNotasFiscais = 0;

      let destinoAtual = null;
      let subtotalDestino = 0;

      dados.forEach(element => {
        data.data = dateFormat(element.data, 'dd/mm/yyyy');

        data.numero = element.numeroCt;
        data.serie = element.serie;
        data.chaveAcesso = element.chaveAcesso;

        switch (element.tipoTomador) {
          case 'REMETENTE':
            data.tomador = element.remetente.razaoSocial;
            break;
          case 'EXPEDIDOR':
            data.tomador = element.expedidor.razaoSocial;
            break;
          case 'RECEBEDOR':
            data.tomador = element.recebedor.razaoSocial;
            break;
          case 'DESTINATARIO':
            data.tomador = element.destinatario.razaoSocial;
            break;
          default:
            break;
        }

        data.destino = element.xmunFim;
        data.codSit = element.codSit;
        data.totalCt = formataMoeda(element.totalVNF);

        valorTotalNotasFiscais = valorTotalNotasFiscais + +element.totalVNF;

        if (ordenarPorCidade) {
          // primeira linha
          if (destinoAtual === null) {
            destinoAtual = data.destino;
          }

          // mudou o destino → insere subtotal antes de trocar
          if (destinoAtual !== data.destino) {
            result.push({
              destino: destinoAtual,
              codSit: 'subtotal',
              totalCt: formataMoeda(subtotalDestino),
            });

            // reset
            subtotalDestino = 0;
            destinoAtual = data.destino;
          }

          // acumula
          subtotalDestino += element.totalVNF;
        }

        result.push({ ...data });
      });

      if (destinoAtual !== null) {
        result.push({
          destino: destinoAtual,
          codSit: 'subtotal',
          totalCt: formataMoeda(subtotalDestino),
        });
      }

      // linha em branco
      data = {
        data: '',
        numero: '',
        serie: '',
        chaveAcesso: '',
        tipoTomador: '',
        destino: '',
        codSit: '',
        totalCt: '',
      };
      result.push({ ...data });

      data = {
        data: '',
        numero: '',
        serie: '',
        chaveAcesso: '',
        tipoTomador: '',
        destino: '',
        codSit: '',
        totalCt: formataMoeda(valorTotalNotasFiscais),
      };
      result.push({ ...data });

      doc.autoTable({
        styles: { fontSize: 8 },
        margin: { top: 38, left: 5, right: 5 },
        columnStyles: {
          0: { cellWidth: 19 },
          1: { cellWidth: 14 },
          2: { cellWidth: 11 },
          5: { cellWidth: 21 },
        },
        theme: 'grid',
        head: headRows,
        body: result,
        didParseCell: dados => {
          const row = dados.row.raw;
          if (row.codSit === 'subtotal') {
            dados.cell.styles.fontStyle = 'bold';
            dados.cell.styles.fillColor = [220, 220, 220]; // cinza claro
            dados.cell.styles.textColor = [0, 0, 0];
          }
        },
        didDrawPage: dados => {
          // Header
          doc.rect(5, 5, 200, 30);
          doc.addImage(img, 'JPEG', 9, 12, 25, 15);
          doc.setFontSize(20);
          doc.text('Relatório de CT-e', 77, 15);

          doc.setFontSize(8);
          doc.text('Situação:', 50, 27);
          doc.text(codSit, 63, 27);
          doc.setFontSize(8);
          doc.text('Período:', 50, 32);
          doc.text(dateFormat(findDataInicial, 'dd/mm/yyyy'), 63, 32);
          doc.text(' à ', 79, 32);
          doc.text(dateFormat(findDataFinal, 'dd/mm/yyyy'), 83, 32);

          // footer
          const { pageSize } = doc.internal;
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(`Pag ${doc.internal.getNumberOfPages()}`, dados.settings.margin.right, pageHeight - 8);
          doc.text('Elo Informática Barbacena LTDA', 844, pageHeight - 8);
          const periodo = new Date();
          doc.text('Impresso: ', 169, pageHeight - 8);
          doc.text((`${('00' + periodo.getDate()).slice(-2)}/${('00' + (+periodo.getMonth() + 1)).slice(-2)}/${periodo.getFullYear()}`).toString(), 186, pageHeight - 8);
        },
      });
      window.open(doc.output('bloburl'));
    } catch (e) {
      toast.warn('Não foi possível gerar a impressão, ' + e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function verificarSeMultiEmpresa() {
      try {
        setIsLoading(true);

        const params = `/usuario/${idUsuario}`;

        const response = await axiosAdmin.get(params);

        const _listaEmpresas = get(response.data, 'listaEmpresas', []);

        const listDropdown = [];

        const _cnpjConsultaPrevisaoFinanceiraCjpEmpresa = store.getState().auth.consultaPrevisaoFinanceiraCnpjEmpresa;

        let cnpjPreenchido = false;
        let _cnpjEmpresaStore = get(store.getState().auth, 'cnpjEmpresa', '');

        if (_cnpjConsultaPrevisaoFinanceiraCjpEmpresa === null || _cnpjConsultaPrevisaoFinanceiraCjpEmpresa === '') {
          if (_cnpjEmpresaStore !== null && _cnpjEmpresaStore !== '') {
            setCnpjEmpresa(_cnpjEmpresaStore);
            const consultaPrevisaoFinanceiraCnpjEmpresa = _cnpjEmpresaStore;
            dispatch(actions.consultaPrevisaoFinanceiraCnpjEmpresaChange({ consultaPrevisaoFinanceiraCnpjEmpresa }));
            cnpjPreenchido = true;
          }
        }

        _listaEmpresas.forEach(element => {
          if (!cnpjPreenchido && (_cnpjConsultaPrevisaoFinanceiraCjpEmpresa === null || _cnpjConsultaPrevisaoFinanceiraCjpEmpresa === '')) {
            setCnpjEmpresa(element.cnpj);
            const consultaPrevisaoFinanceiraCnpjEmpresa = element.cnpj;
            dispatch(actions.consultaPrevisaoFinanceiraCnpjEmpresaChange({ consultaPrevisaoFinanceiraCnpjEmpresa }));
            _cnpjEmpresaStore = element.cnpj;
            cnpjPreenchido = true;
          }

          const nomeEmpresa = element.nomeFantasia ? element.nomeFantasia : element.razaoSocial;

          listDropdown.push({ label: nomeEmpresa, value: element.cnpj, serie: element.nfeSerie, uf: element.uf });
        });

        listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

        setListaEmpresas(listDropdown);

        if (!cnpjPreenchido && _cnpjConsultaPrevisaoFinanceiraCjpEmpresa !== null && _cnpjConsultaPrevisaoFinanceiraCjpEmpresa !== '') {
          setCnpjEmpresa(_cnpjConsultaPrevisaoFinanceiraCjpEmpresa);
          _cnpjEmpresaStore = _cnpjConsultaPrevisaoFinanceiraCjpEmpresa;
        }
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    if (findDataInicial === null) {
      setFindDataInicial(new Date(store.getState().auth.consultaPrevisaoFinanceiraDataInicial));
      setFindDataFinal(new Date(store.getState().auth.consultaPrevisaoFinanceiraDataFinal));

      const _dataInicial = new Date(store.getState().auth.consultaPrevisaoFinanceiraDataInicial);
      const _dataFinal = new Date(store.getState().auth.consultaPrevisaoFinanceiraDataFinal);

      const searchFilter = { findDataInicial: _dataInicial, findDataFinal: _dataFinal };

      verificarSeMultiEmpresa(get(store.getState().auth.user, 'id', 0), searchFilter);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleFind = () => {
    const searchFilter = { findDataInicial, findDataFinal };

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    const loadImage = async () => {
      let config = '';
      try {
        config = await axiosAdmin.get(`/configuracaosistema?idUsuario=${idUsuario}`);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      }

      const img = new Image();
      img.src = `/logotipos/${config.data.urlLogotipo}`;
      await img.decode().then(() => {

      }).catch(() => {
        img.src = 'logo.png';
      });
      getData(searchFilter, cnpjEmpresa, 0, lazyParams.rows, img);
    };
    loadImage();
  };

  return (
    <>
      <Loading isLoading={isLoading} />

      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'center' }}> Relatório de Notas Fiscais </h6>
        </div>

        <div className="row form-elo">
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data inicial
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataInicial}
                onChange={(e) => setFindDataInicial(e.value)}
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data final
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataFinal}
                onChange={(e) => setFindDataFinal(e.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Situação
              </Input155px>
              <Dropdown
                options={listaSituacaoDocumento}
                value={codSit}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setCodSit(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            <div className="field-checkbox">
              <Checkbox
                checked={ordenarPorCidade}
                onChange={e => setOrdenarPorCidade(e.checked)}
              />
              <label htmlFor="binary">
                &nbsp;Ordenar por Cidade
              </label>
            </div>
          </div>
          <div className="col-lg-1">
            <button
              type="button"
              title="Imprimir"
              className="btn btn-success"
              style={{ borderRadius: '15px' }}
              onClick={handleFind}
            >
              <i className="pi pi-print"></i>
            </button>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-lg-6">
            {listaEmpresas.length > 1 ? (
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Empresa
                </Input100px>
                <Dropdown
                  options={listaEmpresas}
                  value={cnpjEmpresa}
                  emptyMessage="Nenhum registro a ser exibido"
                  onChange={(e) => {
                    setCnpjEmpresa(e.target.value);
                  }}
                />
              </div>
            ) : ('')}
          </div>
        </div>
      </Card>
    </>
  );
}
